import { MutationResponse } from "../../domain/models/http/MutationsRequest";
import QueryService from "../QueryService";

class UserMutationService extends QueryService<never> {
  public constructor(baseURL: string, pathname: string) {
    super(baseURL, pathname);
  }

  public async updateLanguage(
    userId: string,
    language: string,
  ): Promise<MutationResponse> {
    const response = await this.api.post(`${this.pathname}/mutate`, {
      mutate: [
        {
          operation: "update",
          key: userId,
          attributes: {
            locale: language,
          },
        },
      ],
    });
    return response.data;
  }
}

const BASE_URL = process.env.NEXT_PUBLIC_FLUX_API_URL as string;
const userMutationService = new UserMutationService(BASE_URL, "users");
export { userMutationService };
